var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    patternUnits: "userSpaceOnUse",
    id: "master_svg0_12_0105"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAPCSURBVHic7d1RcuMoFEBR1CvLrGy8M7tXxvzYM+mqvLEtI+Chc346P11BwA2OoiqVAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwA+20QOAvWqtX/cv/y6l/L5/fdu27TZwWDBWrfVSn7uMHid0VWv9qrVeX4jj4frtlIF13ePYSySs68M4aq31Ovoa4BAN4njY9TuJu1hM6/7RqNlP/23b3t7vv1p9c2ipdRzlz9vCLxMI0zkijr0EwlQOjsMJQl4znRwPAmEKneJ4+xEUd7EYrtfJ4S4W6XT8WOUBRnJp+EfAV3jchDw6x+HJXvLoHMdUd8Xgf4kDAuKAgDggIA4IiAMC4oCAOCAgDgiIAwLigIA4ICAOCIgDAuKAgDggIA4IiAMC4oCAOCAgDgiIAwLigIA4ICAOCIgDAuKAgDggIA4IiAMC4oCAOCAgDgiIAwLigIA49mn6nvRvbxJ9/Hvbts3rdwfr+Krlcl/zvzp9rxxqrZdnP1G8hncMJ8dA98m/vjGBXsfbkTgGeuHUMJEDiWMwEzovcQz2welhYg8mjsEaL4AJbkgc7f3a8X9a3o36OstEH82t3GPsCaQ1kXxIHBN587auI/tgPlYda4YT5MFJ8iYnx/H2BPL7gHE8iORF4uhjTyBHP1slkifE0c9MH7G+E0lAHAk0+kOhXwrf5BfyRA68m2WhfiCOZCxYP+Y6KQt3PHOcnAU8jrldhIVsz5wuxoK2Yy4XZWE/Zw4XZ4H3M3cnYaHfZ85OxoK/zlydlIV/zhydnA0QMzeUYiP8yJzwBxviP+aCH9kY5oAnzrxBznztvOGMG+WM18wHzrRhznStNHSGjXOGa+RAK2+gla+NjlbcSCteEwOttKFWuhYmssLGWuEamFjmDZZ57CSScaNlHDOJZdpwmcbKQjJsvAxjZGEzb8CZx8aJzLgRZxwTJzbThpxpLPCvGTbmDGOA0MgNKg5SGLFRxXFO2+gB7NX7VWSllK9e38trz+aRNpDSP5IexDGZ1IGUtSIRx4TSB1LWiEQck1oikJI7EnFMbJlASs5IxDG5pQIpuSIRRwLLBVJyRCKOJJYMpMwdiTgSWTaQMmck4khm6UDKXJGIgzl1fo7Ks1XkMzAScZDDgEjEQS4dIxEHOXWIRBzkdmAk4mANB0QiDtbSMBJxsKYGkYiDtX0QiTg4j1rr5Y04LqPHC929EMn1/owXi1v+YcVPfTslbqWUsm3bbeyIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAa+gfPKmaTU25c0AAAAABJRU5ErkJggg=="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    rx: 0,
    fill: "url(#master_svg0_12_0105)",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGou);
export default __webpack_public_path__ + "static/media/gou.42077823a94afa77dfe538bc665ab8d7.svg";
export { ForwardRef as ReactComponent };